/* LF · Winkelwagen (Thema v2, 29-10-2026). Eén script voor de lade (sections/lf-lade) en /cart
   (sections/lf-cart-pagina). Regels:
   - alles loopt door één wachtrij: nooit twee cart-verzoeken tegelijk;
   - na elk verzoek wordt de sectie opnieuw van de server gehaald en vervangen (bevestigde staat).
     Eén uitzondering (SNELFIX 29-10): verzekerde verzending tekent meteen zelf (vinkje, status,
     subtotaal, afrekenbedrag), stuurt het verzoek op de achtergrond en ververst daarna stil; bij een
     fout terug naar de oude staat met een korte melding. Tot het antwoord er is, telt een klik niet;
   - window.lfCart.open()/sync() blijven bestaan, zodat lodyfair-product.js, -quick-add.js,
     -staffelkiezer.js, -bijnabar.js en -outfit-week.js ongewijzigd werken (ze roepen lfCart.open of
     sturen 'ajaxProduct:added');
   - cadeaus (Nike sokken / Calvin Klein 3-pack) volgen de ladder: bij ≥ drempel toevoegen, eronder
     weghalen; de automatische BXGY-kortingen van Shopify maken ze €0. Blijkt een cadeau tóch betaald
     (BXGY niet toegepast), dan gaat het eruit en wordt het voor die stand niet opnieuw geprobeerd;
   - kortingscode via /cart/update.js {discount}, status uit discount_codes[].applicable;
   - dubbelklik: knoppen zijn tijdens een verzoek uitgeschakeld, en de wachtrij maakt twee gelijke
     verzoeken onschadelijk (het tweede ziet de nieuwe staat). */
(function () {
  'use strict';
  var html = document.documentElement;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lade = document.querySelector('[data-lf-lade]');
  var pagina = document.querySelector('[data-lf-lade-pagina]');
  if (!lade && !pagina) return;
  var EN = (html.lang || 'nl').slice(0, 2) !== 'nl';
  var T = EN
    ? { fout: 'Something went wrong. Please try again.', code_ok: 'Code applied', code_fout: 'This code is invalid or does not apply to these items.', code_combi: 'Code not applied: invalid, or not combinable with %code%.', code_leeg: 'Enter a code first.', bezig: 'One moment…' }
    : { fout: 'Er ging iets mis. Probeer het nog een keer.', code_ok: 'Code toegepast', code_fout: 'Deze code is ongeldig of geldt niet voor deze producten.', code_combi: 'Code niet toegepast: ongeldig, of niet te combineren met %code%.', code_leeg: 'Vul eerst een code in.', bezig: 'Momentje…' };

  var keten = Promise.resolve();
  var optGen = 0;   /* +1 bij elke zelf getekende wijziging: een verversing die daarvóór begon, tekent niet over */
  function inKeten(werk) { var p = keten.then(werk, werk); keten = p.catch(function () {}); return p; }

  /* ---------- tekenen ---------- */
  function doelen() {
    var uit = [];
    if (lade) uit.push({ el: lade.querySelector('[data-lf-paneel]'), url: root + '?sections=lf-lade', id: 'lf-lade' });
    if (pagina) uit.push({ el: pagina.querySelector('[data-lf-paneel]'), url: root + 'cart?sections=' + encodeURIComponent(pagina.dataset.sectie), id: pagina.dataset.sectie });
    return uit;
  }
  function telling(n) {
    document.querySelectorAll('[data-lf-cart-telling]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = n; });
  }
  function bewaarStaat(el) {
    var d = el.querySelector('[data-lf-korting]');
    var v = el.querySelector('.lf-korting__veld');
    var s = el.querySelector('[data-lf-code-status]');
    var sc = el.querySelector('[data-lf-scroll]');
    return { open: !!(d && d.open), waarde: v ? v.value : '', status: s ? { tekst: s.textContent, klasse: s.className } : null, focusCode: document.activeElement === v, scroll: sc ? sc.scrollTop : 0 };
  }
  function herstelStaat(el, st) {
    if (!st) return;
    var d = el.querySelector('[data-lf-korting]');
    var v = el.querySelector('.lf-korting__veld');
    var s = el.querySelector('[data-lf-code-status]');
    var sc = el.querySelector('[data-lf-scroll]');
    if (d && st.open) d.open = true;
    if (v && st.waarde) v.value = st.waarde;
    if (s && st.status) { s.textContent = st.status.tekst; s.className = st.status.klasse; }
    if (v && st.focusCode) v.focus();
    if (sc && st.scroll) sc.scrollTop = st.scroll;
  }
  function ververs() {
    var lijst = doelen();
    var gen = optGen;
    return Promise.all(lijst.map(function (d) {
      if (!d.el) return null;
      /* geen Accept: application/json: /cart geeft dan cart.js-JSON in plaats van de sectie */
      return fetch(d.url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('sectie')); })
        .then(function (tekst) {
          var json; try { json = JSON.parse(tekst); } catch (e) { return; }
          /* Section Rendering API geeft {"<sectie-id>": "<html>"}; eerst JSON, dan pas HTML parsen */
          var htmlTekst = json && json[d.id];
          if (typeof htmlTekst !== 'string') return;
          var doc = new DOMParser().parseFromString(htmlTekst, 'text/html');
          var nieuw = doc.querySelector('[data-lf-paneel]');
          if (!nieuw || gen !== optGen) return;
          var st = bewaarStaat(d.el);
          d.el.innerHTML = nieuw.innerHTML;
          herstelStaat(d.el, st);
          var inhoud = d.el.querySelector('[data-lf-inhoud]');
          if (inhoud) telling(parseInt(inhoud.dataset.count, 10) || 0);
        });
    })).then(function () { syncCadeau(); document.dispatchEvent(new CustomEvent('lf:cart:ververst')); });
  }

  /* ---------- verzoeken ---------- */
  function stuur(pad, body) {
    return fetch(root + pad, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (json) {
        if (!r.ok) { var f = new Error(json.description || json.message || 'cart'); f.json = json; throw f; }
        return json;
      });
    });
  }
  function post(pad, body) {
    return stuur(pad, body).then(function (json) { return ververs().then(function () { return json; }); }, function (f) { return ververs().then(function () { throw f; }); });
  }
  function bezig(aan) {
    doelen().forEach(function (d) { if (d.el) d.el.classList.toggle('is-bezig', aan); });
  }
  function doe(pad, body) {
    bezig(true);
    return inKeten(function () { return post(pad, body); }).finally(function () { bezig(false); });
  }

  /* ---------- lade open/dicht ---------- */
  var vorigeFocus = null;
  function open() {
    if (!lade) return Promise.resolve();
    return inKeten(ververs).then(function () {
      if (html.classList.contains('lf-lade-open')) return;
      vorigeFocus = document.activeElement;
      html.classList.add('lf-lade-open');
      lade.setAttribute('aria-hidden', 'false');
      /* focus naar het paneel (geen zichtbare ring); Tab gaat daarna naar de sluitknop */
      var p = lade.querySelector('[data-lf-paneel]');
      if (p) { p.setAttribute('tabindex', '-1'); setTimeout(function () { p.focus({ preventScroll: true }); }, 60); }
    });
  }
  function sluit() {
    if (!lade || !html.classList.contains('lf-lade-open')) return;
    html.classList.remove('lf-lade-open');
    lade.setAttribute('aria-hidden', 'true');
    if (vorigeFocus && vorigeFocus.focus) { try { vorigeFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- cadeaus ---------- */
  var cadeauLaatst = '';
  var cadeauGeweigerd = {};   /* stand → true: cadeau bleek niet gratis bij deze samenstelling */
  function syncCadeau() {
    var l = document.querySelector('[data-lf-ladder]');
    if (!l) { cadeauLaatst = ''; return; }
    var telt = parseInt(l.dataset.telt, 10) || 0;
    var d1 = parseInt(l.dataset.d1, 10), d2 = parseInt(l.dataset.d2, 10);
    var tier2 = l.dataset.tier2 === 'true';
    var heeft1 = !!l.dataset.in1, heeft2 = !!l.dataset.in2;
    var betaald1 = l.dataset.in1Betaald === 'true', betaald2 = l.dataset.in2Betaald === 'true';
    var stand = [telt, tier2].join(':');
    var updates = {}, iets = false;
    /* een cadeau dat tóch geld kost (BXGY niet toegepast): eruit, en niet opnieuw proberen voor deze stand */
    if (heeft1 && betaald1) { updates[l.dataset.v1] = 0; cadeauGeweigerd[stand + ':1'] = true; iets = true; }
    if (heeft2 && betaald2) { updates[l.dataset.v2] = 0; cadeauGeweigerd[stand + ':2'] = true; iets = true; }
    var wil1 = telt >= d1 && !cadeauGeweigerd[stand + ':1'];
    var wil2 = tier2 && telt >= d2 && !cadeauGeweigerd[stand + ':2'];
    if (!betaald1 && wil1 !== heeft1) { updates[l.dataset.v1] = wil1 ? 1 : 0; iets = true; }
    if (!betaald2 && wil2 !== heeft2) { updates[l.dataset.v2] = wil2 ? 1 : 0; iets = true; }
    if (!iets) { cadeauLaatst = ''; return; }
    var sleutel = stand + '|' + JSON.stringify(updates);
    if (sleutel === cadeauLaatst) return;   /* al geprobeerd voor deze stand: niet blijven hameren */
    cadeauLaatst = sleutel;
    doe('cart/update.js', { updates: updates }).catch(function () {});
  }

  /* ---------- kortingscode ---------- */
  function status(el, tekst, soort) {
    var s = el.querySelector('[data-lf-code-status]');
    if (!s) return;
    s.textContent = tekst || '';
    s.className = 'lf-korting__status' + (soort ? ' is-' + soort : '');
  }
  function codes(json) { return (json && json.discount_codes) || []; }
  function pasCodeToe(form) {
    var wrap = form.closest('[data-lf-paneel]') || document;
    var veld = form.querySelector('.lf-korting__veld');
    var knop = form.querySelector('.lf-korting__knop');
    var code = (veld.value || '').trim();
    if (!code) { status(wrap, T.code_leeg, 'fout'); veld.focus(); return; }
    if (knop && knop.disabled) return;
    if (knop) knop.disabled = true;
    var bestaand = Array.prototype.map.call(wrap.querySelectorAll('[data-lf-code-weg]'), function (b) { return b.dataset.lfCodeWeg; });
    var alle = bestaand.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]);
    status(wrap, T.bezig, 'bezig');
    doe('cart/update.js', { discount: alle.join(',') }).then(function (json) {
      var w = (lade && lade.contains(wrap)) ? lade : (pagina || document);
      var cs = codes(json);
      var mijn = cs.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      var anderOk = cs.some(function (c) { return c.applicable && c.code.toLowerCase() !== code.toLowerCase(); });
      if (mijn && mijn.applicable) {
        status(w, T.code_ok + ' · ' + code.toUpperCase(), 'ok');
        var v2 = w.querySelector('.lf-korting__veld'); if (v2) v2.value = '';
      } else {
        var anderCode = (cs.filter(function (c) { return c.applicable && c.code.toLowerCase() !== code.toLowerCase(); })[0] || {}).code;
        status(w, anderOk ? T.code_combi.replace('%code%', anderCode || '') : T.code_fout, 'fout');
        var v3 = w.querySelector('.lf-korting__veld'); if (v3) { v3.value = code; v3.focus(); }
        /* een geweigerde code niet in de cart laten hangen */
        if (mijn && !mijn.applicable) doe('cart/update.js', { discount: bestaand.join(',') }).catch(function () {});
      }
    }).catch(function () { status(wrap, T.fout, 'fout'); }).finally(function () {
      var k = (lade || pagina || document).querySelector('.lf-korting__knop'); if (k) k.disabled = false;
    });
  }
  function haalCodeWeg(code, wrap) {
    var bestaand = Array.prototype.map.call(wrap.querySelectorAll('[data-lf-code-weg]'), function (b) { return b.dataset.lfCodeWeg; });
    var rest = bestaand.filter(function (c) { return c !== code; });
    status(wrap, '', '');
    doe('cart/update.js', { discount: rest.join(',') }).catch(function () {});
  }

  /* ---------- verzekerde verzending (direct tekenen) ---------- */
  function geld(cent, fmt) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt || '');
    var soort = m ? m[1] : 'amount_with_comma_separator';
    var dec = soort.indexOf('no_decimals') < 0 ? 2 : 0;
    var komma = soort.indexOf('comma_separator') >= 0;
    var delen = (cent / 100).toFixed(dec).split('.');
    var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, komma ? '.' : ',');
    var bedrag = heel + (delen[1] ? (komma ? ',' : '.') + delen[1] : '');
    return m ? fmt.replace(m[0], bedrag) : '€' + bedrag;
  }
  function tekenBescherming(aan) {
    var terug = [];
    document.querySelectorAll('[data-lf-inhoud]').forEach(function (inh) {
      var box = inh.querySelector('[data-lf-besch]');
      if (!box) return;
      var vk = box.querySelector('[data-lf-bescherming]');
      var st = box.querySelector('[data-lf-besch-status]');
      /* subtotaal heeft een eigen element; in de afrekenknop (flex) alleen het bedrag na de punt vervangen */
      var bedragen = inh.querySelectorAll('[data-lf-bedrag], [data-lf-afrekenen]');
      var oud = { aan: box.dataset.aan, total: inh.dataset.total, status: st ? st.textContent : '', bedrag: Array.prototype.map.call(bedragen, function (b) { return b.textContent; }) };
      terug.push(function () {
        box.dataset.aan = oud.aan; inh.dataset.total = oud.total;
        var was = oud.aan === 'true';
        box.classList.toggle('is-aan', was); if (vk) vk.checked = was;
        if (st) st.textContent = oud.status;
        bedragen.forEach(function (b, i) { b.textContent = oud.bedrag[i]; });
      });
      if (vk) vk.checked = aan;
      box.classList.toggle('is-aan', aan);
      if (st) st.textContent = aan ? box.dataset.tekstAan : box.dataset.tekstUit;
      if ((box.dataset.aan === 'true') === aan) return;
      box.dataset.aan = String(aan);
      var totaal = (parseInt(inh.dataset.total, 10) || 0) + (aan ? 1 : -1) * (parseInt(box.dataset.cent, 10) || 0);
      inh.dataset.total = totaal;
      var nieuw = geld(totaal, inh.dataset.money);
      bedragen.forEach(function (b) { b.textContent = b.hasAttribute('data-lf-afrekenen') ? b.textContent.replace(/·[^·]*$/, '· ' + nieuw) : nieuw; });
    });
    return function () { terug.forEach(function (f) { f(); }); };
  }
  /* korte melding in de statusregel; na 4 s weer de gewone status */
  function meldFout() {
    document.querySelectorAll('[data-lf-besch-status]').forEach(function (s) { s.textContent = T.fout; });
    setTimeout(function () {
      document.querySelectorAll('[data-lf-besch]').forEach(function (box) {
        var s = box.querySelector('[data-lf-besch-status]');
        if (s && s.textContent === T.fout) s.textContent = box.dataset.aan === 'true' ? box.dataset.tekstAan : box.dataset.tekstUit;
      });
    }, 4000);
  }
  var beschBezig = false;
  function zetBescherming(vink) {
    if (beschBezig) return;
    beschBezig = true;
    optGen++;
    var aan = vink.checked;
    var terug = tekenBescherming(aan);
    var u = {}; u[vink.dataset.variant] = aan ? 1 : 0;
    inKeten(function () { return stuur('cart/update.js', { updates: u }); }).then(function () {
      beschBezig = false;
      inKeten(ververs);
    }, function () {
      beschBezig = false;
      optGen++;
      terug();
      meldFout();
      inKeten(ververs).then(meldFout);
    });
  }

  /* ---------- gebeurtenissen ---------- */
  /* data-regels="<key>=<aantal>,…": alle cartregels van één variant (Shopify splitst soms bij korting/cadeau) */
  function regelsVan(item) {
    return ((item && item.dataset.regels) || '').split(',').filter(Boolean).map(function (r) {
      var i = r.lastIndexOf('='); return { key: r.slice(0, i), q: parseInt(r.slice(i + 1), 10) || 0 };
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (beschBezig && t.closest('[data-lf-besch] [data-lf-bescherming]')) { e.preventDefault(); return; }
    var tas = t.closest('.js-drawer-open-cart, [data-lf-lade-open], a[href$="/cart"].header__icon');
    if (tas && lade) { e.preventDefault(); open(); return; }
    if (t.closest('[data-lf-lade-sluit]')) { e.preventDefault(); sluit(); return; }
    if (t.closest('[data-lf-lade-sluit-link]')) { sluit(); return; }
    var step = t.closest('[data-lf-step]');
    if (step) {
      var item = step.closest('[data-lf-item]');
      if (item.classList.contains('is-bezig') || step.disabled) return;
      /* per regel-key: Shopify splitst één variant soms in deelregels (korting/cadeau); een
         update op variant-id zet dan elke deelregel op het totaal en het aantal verdubbelt */
      var regels = regelsVan(item);
      var plus = parseInt(step.dataset.lfStep, 10) > 0;
      var regel = plus ? regels[0] : regels.filter(function (r) { return r.q > 0; }).pop();
      if (!regel) return;
      item.classList.add('is-bezig');
      item.querySelectorAll('[data-lf-step], [data-lf-verwijder]').forEach(function (b) { b.disabled = true; });
      doe('cart/change.js', { id: regel.key, quantity: Math.max(0, regel.q + (plus ? 1 : -1)) }).catch(function () {});
      return;
    }
    var weg = t.closest('[data-lf-verwijder]');
    if (weg) {
      var it = weg.closest('[data-lf-item]');
      if (it.classList.contains('is-bezig')) return;
      it.classList.add('is-bezig');
      it.querySelectorAll('[data-lf-step], [data-lf-verwijder]').forEach(function (b) { b.disabled = true; });
      /* elke deelregel op 0 via zijn key (variant-id raakt bij gesplitste regels er maar één) */
      var u0 = {};
      regelsVan(it).forEach(function (r) { u0[r.key] = 0; });
      if (!Object.keys(u0).length) u0[it.dataset.variant] = 0;
      doe('cart/update.js', { updates: u0 }).catch(function () {});
      return;
    }
    var toon = t.closest('[data-lf-maat-toon]');
    if (toon) {
      var sel = toon.closest('.lf-item__info').querySelector('[data-lf-maat]');
      if (sel) { sel.hidden = false; toon.hidden = true; sel.focus(); }
      return;
    }
    var cw = t.closest('[data-lf-code-weg]');
    if (cw) { haalCodeWeg(cw.dataset.lfCodeWeg, cw.closest('[data-lf-paneel]') || document); return; }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-lf-maat]');
    if (sel) {
      var nieuw = parseInt(sel.value, 10), oud = parseInt(sel.dataset.variant, 10), aantal = parseInt(sel.dataset.qty, 10) || 1;
      if (!nieuw || nieuw === oud) return;
      sel.disabled = true;
      /* oude maat: elke deelregel via zijn key op 0; staat de nieuwe maat er al, dan erbij optellen */
      var updates = {}, item = sel.closest('[data-lf-item]');
      regelsVan(item).forEach(function (r) { updates[r.key] = 0; });
      if (!Object.keys(updates).length) updates[oud] = 0;
      var wrap = sel.closest('[data-lf-paneel]') || document;
      var al = wrap.querySelector('[data-lf-item][data-variant="' + nieuw + '"]');
      var alR = al ? regelsVan(al) : [];
      if (alR.length) updates[alR[0].key] = alR[0].q + aantal; else updates[nieuw] = aantal;
      doe('cart/update.js', { updates: updates }).catch(function () { sel.disabled = false; sel.value = String(oud); });
      return;
    }
    var vink = e.target.closest('[data-lf-besch] [data-lf-bescherming]');
    if (vink) zetBescherming(vink);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-lf-code-form]');
    if (form) { e.preventDefault(); pasCodeToe(form); return; }
    var af = e.target.closest('.lf-lade__afrekenen');
    if (af) { var b = af.querySelector('[data-lf-afrekenen]'); if (b) { if (b.classList.contains('is-bezig')) { e.preventDefault(); return; } b.classList.add('is-bezig'); b.setAttribute('aria-busy', 'true'); } }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && html.classList.contains('lf-lade-open')) sluit();
  });

  document.addEventListener('ajaxProduct:added', function () { open(); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      /* terug met de terugknop (bfcache): staat verversen en een hangende afrekenknop loslaten */
      document.querySelectorAll('[data-lf-afrekenen].is-bezig').forEach(function (b) { b.classList.remove('is-bezig'); b.removeAttribute('aria-busy'); });
      inKeten(ververs);
    }
  });

  /* eerste staat: cadeaus voor wat de server al tekende */
  syncCadeau();

  window.lfCart = { open: open, sluit: sluit, ververs: function () { return inKeten(ververs); }, sync: function () { return inKeten(ververs); } };
})();
